(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* Original */

  (function () {
    const ROOT = document.documentElement;
    const VAR_STICKY = '--sticky-header-height';
    const VAR_VH = '--viewport-height';
    const VAR_VH_WITHOUT = '--viewport-height-without-sticky-header';
    const VAR_STICKY_POS_FIXED = '--sticky-header-position-fixed';
    const VAR_ITEMS = '--header-items-inner-height';

    function setHeightVarById(id, varName) {
      const el = document.getElementById(id);
      if (!el) {
        ROOT.style.setProperty(varName, '0px');
        return;
      }
      const h = Math.round(el.getBoundingClientRect().height);
      ROOT.style.setProperty(varName, `${h}px`);
    }

    function updateVars() {
      const headerEl = document.querySelector('header.header');
      const viewportHeight = window.innerHeight;

      ROOT.style.setProperty(VAR_VH, `${viewportHeight}px`);

      const headerGroupEl = document.querySelector('.section-header');
      if (headerGroupEl) {
        const rect = headerGroupEl.getBoundingClientRect();
        ROOT.style.setProperty(VAR_STICKY_POS_FIXED, `${Math.round(rect.top)}px`);
      } else {
        ROOT.style.setProperty(VAR_STICKY_POS_FIXED, '0px');
      }

      if (!headerEl) {
        ROOT.style.setProperty(VAR_STICKY, '0px');
        ROOT.style.setProperty(VAR_VH_WITHOUT, `${viewportHeight}px`);
      } else {
        const rect = headerEl.getBoundingClientRect();
        const stickyHeight = rect.top + rect.height;
        ROOT.style.setProperty(VAR_STICKY, `${Math.round(stickyHeight)}px`);
        ROOT.style.setProperty(
          VAR_VH_WITHOUT,
          `${Math.round(viewportHeight - stickyHeight)}px`
        );
      }

      // ▼ Items のみ
      setHeightVarById('header-items-inner', VAR_ITEMS);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateVars);
    } else {
      updateVars();
    }

    window.addEventListener('scroll', updateVars, { passive: true });
    window.addEventListener('resize', updateVars);
    window.addEventListener('load', updateVars);

    if ('ResizeObserver' in window) {
      const el = document.getElementById('header-items-inner');
      if (el) {
        const ro = new ResizeObserver(() => {
          const h = Math.round(el.getBoundingClientRect().height);
          ROOT.style.setProperty(VAR_ITEMS, `${h}px`);
        });
        ro.observe(el);
      }
    }
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-information"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.flash-list > li');
  const texts = document.querySelectorAll('.flash-list-text');

  const setOpenHeight = (li) => {
    const text = li.querySelector('.flash-list-text');
    const inner = li.querySelector('.flash-list-text-inner');
    if (!text || !inner) return;
    text.style.height = `${inner.scrollHeight}px`;
  };

  const setClosedHeight = (li) => {
    const text = li.querySelector('.flash-list-text');
    if (!text) return;
    text.style.height = '0px';
  };

  items.forEach((li) => {
    if (li.classList.contains('open')) {
      setOpenHeight(li);
    } else {
      setClosedHeight(li);
    }
  });

  const style = document.createElement('style');
  style.textContent = `.flash-list-text{transition: height 0.3s ease-in-out;}`;
  document.head.appendChild(style);

  document.querySelectorAll('.flash-list .flash-list-title').forEach((title) => {
    title.addEventListener('click', () => {
      const li = title.closest('li');
      if (!li) return;

      const isOpen = li.classList.toggle('open');
      if (isOpen) {
        setOpenHeight(li);
      } else {
        setClosedHeight(li);
      }
    });
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('.flash-list > li.open').forEach(setOpenHeight);
  });
});

  } catch(e) { console.error(e); }
})();
})();
